import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';
import '../styles/LegalPages.css';

const CookiePolicy = () => {
  // Scroll to top on mount - immediate
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="legal-page">
      <SEO canonical="/cookie-policy" />
      <header className="legal-header">
        <div className="container">
          <Link to="/" className="legal-back-link">
            <ArrowLeft size={18} />
            <span>Back to Home</span>
          </Link>
          <Link to="/" className="legal-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_accordion-repair/artifacts/06uiebgi_Variant%201_Full%20Logo_Vector%20copy%202.png" 
              alt="All Secured" 
            />
          </Link>
        </div>
      </header>

      <main className="legal-content">
        <div className="container">
          <article className="legal-article">
            <h1>Cookie Policy</h1>
            <p className="legal-subtitle">All Secured Cookie Policy</p>
            <p className="legal-effective-date">Effective Date: 12 February 2026</p>

            <section>
              <h2>1. What Are Cookies?</h2>
              <p>Cookies are small text files placed on your device when you visit a website. They help websites function properly and provide information about usage and performance.</p>
            </section>

            <section>
              <h2>2. How We Use Cookies</h2>
              <p>We use cookies for the following purposes:</p>

              <h3>Essential Cookies</h3>
              <p>Required for core functionality, including:</p>
              <ul>
                <li>Account login</li>
                <li>Session management</li>
                <li>Security protections</li>
              </ul>
              <p>These cookies cannot be disabled as the platform will not function properly without them.</p>

              <h3>Analytics Cookies</h3>
              <p>Used to understand how visitors interact with our website, including:</p>
              <ul>
                <li>Pages visited</li>
                <li>Time spent on site</li>
                <li>General usage patterns</li>
              </ul>
              <p>This helps us improve performance and user experience.</p>

              <h3>Advertising & Tracking Cookies</h3>
              <p>We may use tracking technologies (such as Meta Pixel) to:</p>
              <ul>
                <li>Measure advertising performance</li>
                <li>Understand conversion events (e.g. purchases)</li>
                <li>Improve our marketing campaigns</li>
              </ul>
              <p>These tools may collect information such as IP address and browsing behaviour.</p>
            </section>

            <section>
              <h2>3. Managing Cookies</h2>
              <p>You can control or disable cookies through your browser settings. Please note that disabling essential cookies may prevent the platform from functioning correctly.</p>
            </section>

            <section>
              <h2>4. Third-Party Services</h2>
              <p>Some cookies are set by trusted third-party services we use, including:</p>
              <ul>
                <li>Analytics providers</li>
                <li>Advertising platforms</li>
                <li>Payment processors</li>
              </ul>
              <p>These providers maintain their own privacy policies.</p>
            </section>

            <section>
              <h2>5. Updates</h2>
              <p>We may update this Cookie Policy periodically. The Effective Date reflects the latest version.</p>
            </section>
          </article>
        </div>
      </main>

      <footer className="legal-footer">
        <div className="container">
          <p>&copy; 2025 All Secured. All rights reserved.</p>
          <p className="legal-footer-stripe">Secure payments powered by Stripe.</p>
        </div>
      </footer>
    </div>
  );
};

export default CookiePolicy;
